import { LayoutName } from "@/shared/types/general";
import { UserRole } from "@/shared/types/user";
import { AppRouteRecordRaw } from "./types";

export const ROUTES = [
    /*###############
    ### DASHBOARD ###
    ###############*/
    // 1. Main routes
    {
        name: "dashboard",
        path: "/",
        component: () => import("@/modules/dashboard/views/dashboard/Dashboard.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },
    {
        name: "dashboard-my-account",
        path: "/moje-konto",
        component: () =>
            import("@/modules/dashboard/views/dashboard-my-account/DashboardMyAccount.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },
    {
        name: "dashboard-users-list",
        path: "/uzytkownicy",
        component: () =>
            import("@/modules/dashboard/views/dashboard-users-list/DashboardUsersList.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },
    {
        name: "dashboard-user-details",
        path: "/uzytkownicy/:id",
        component: () =>
            import("@/modules/dashboard/views/dashboard-user-details/DashboardUserDetails.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },
    {
        name: "dashboard-invoicing-platform-connectors",
        path: "/invoicing-platform-connectors",
        component: () =>
            import("@/modules/dashboard/views/dashboard-invoicing-platform-connectors/DashboardInvoicingPlatformConnectors.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN]
        }
    },
    {
        name: "dashboard-api-clients",
        path: "/api-clients",
        component: () =>
            import("@/modules/dashboard/views/dashboard-api-clients/DashboardApiClients.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN]
        }
    },
    {
        name: "dashboard-api-client-details",
        path: "/api-clients/:id",
        component: () =>
            import("@/modules/dashboard/views/dashboard-api-client-details/DashboardApiClientDetails.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN]
        }
    },
    {
        name: "dashboard-invoice-intents",
        path: "/faktury",
        component: () =>
            import("@/modules/dashboard/views/dashboard-invoice-intents/DashboardInvoiceIntents.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },
    {
        name: "dashboard-invoice-intent-details",
        path: "/faktury/:id",
        component: () =>
            import("@/modules/dashboard/views/dashboard-invoice-intent-details/DashboardInvoiceIntentDetails.vue"),
        meta: {
            layout: LayoutName.DASHBOARD,
            public: false,
            allowed_roles: [UserRole.ADMIN, UserRole.ACCOUNTANT]
        }
    },

    // 2. Auth
    {
        path: "/auth/logowanie",
        name: "dashboard-auth-login",
        component: () => import("@/modules/auth/views/DashboardLogin.vue"),
        meta: { layout: LayoutName.DASHBOARD_AUTH, public: true }
    },
    {
        path: "/auth/google",
        name: "dashboard-login-google",
        component: () => import("@/modules/auth/views/DashboardLogin.vue"),
        meta: { layout: LayoutName.DASHBOARD_AUTH, public: true }
    },

    /*###############
    ### ERROR 404 ###
    ###############*/
    {
        path: "/:pathMatch(.*)*",
        name: "e404",
        component: () => import("@/modules/e404/e404.vue"),
        meta: {
            layout: LayoutName.BLANK,
            public: true
        }
    }
] as const satisfies AppRouteRecordRaw[];
